import { createContext, useContext, useState } from "react";
import VideoModal from "@/components/VideoModal";
import { QuoteDialog } from "@/components/RequestForm";

const Ctx = createContext(null);

export function PlayerProvider({ children }) {
  const [video, setVideo] = useState(null);
  const [quoteOpen, setQuoteOpen] = useState(false);
  return (
    <Ctx.Provider
      value={{
        video,
        open: setVideo,
        close: () => setVideo(null),
        quoteOpen,
        openQuote: () => setQuoteOpen(true),
        closeQuote: () => setQuoteOpen(false),
      }}
    >
      {children}
      <VideoModal />
      <QuoteDialog />
    </Ctx.Provider>
  );
}

export const usePlayer = () => useContext(Ctx);
